import { render, staticRenderFns } from "./TabSelect.vue?vue&type=template&id=0882450e&scoped=true&"
import script from "./TabSelect.vue?vue&type=script&lang=js&"
export * from "./TabSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882450e",
  null
  
)

export default component.exports